const Auth = {
    guest: () => window.Laravel.guest,
    is: (role) => (window.Laravel.roles.indexOf(role) != -1),
    user: (window.Laravel) ? window.Laravel.user : null
}

export default Auth;

